<div class="qai-icon" [ngClass]="fileIconClass">